namespace GeniuzPOS.Inventory {
    export class IcStockReceiveColumns {
        static columnsKey = 'Inventory.IcStockReceive';
    }
}
